import Iconify from "../ui/Iconify";
import {
  formatDistance,
  getDistanceMeters,
  getRegionFromAddress,
} from "./search-utils";
import { getRowStyle } from "./search-result-row-styles";
import { ListTile } from "@/components/kit";
import { CLOUDFRONT_BASE_URL } from "../../../config";

// 결과 행 왼쪽에 놓을 대표 사진 주소. 서버가 withCover=true 일 때만 실어 준다.
const getCoverImageUrl = (place) => {
  const cover = place?.coverMedia;
  if (!cover) return "";
  const path =
    cover.thumbnailPath || cover.mediumPath || cover.filePath || cover.mediaPath || "";
  if (!path) return "";
  return String(path).startsWith("http") ? path : `${CLOUDFRONT_BASE_URL}/${path}`;
};

export const SearchActionRow = ({
  icon,
  label,
  onClick,
  muted = false,
  prefix,
  isActive = false,
  onMouseEnter,
  variant = "mobile",
}) => {
  const styles = getRowStyle(variant);

  return (
    <button
      type="button"
      className={`${styles.action} ${
        muted ? "text-black/45 dark:text-white/45" : "text-black dark:text-white"
      } ${
        isActive
          ? "bg-black/[0.06] dark:bg-white/[0.09]"
          : "hover:bg-black/[0.035] dark:hover:bg-white/[0.06]"
      }`}
      onClick={onClick}
      onMouseDown={(event) => {
        if (onClick) event.preventDefault();
      }}
      onMouseEnter={onMouseEnter}
      aria-selected={isActive}
      disabled={!onClick}
    >
      <span className={styles.actionIcon}>
        {prefix ? (
          <span className={styles.actionPrefix}>{prefix}</span>
        ) : (
          <Iconify icon={icon} className={styles.actionIconGlyph} />
        )}
      </span>
      <span className={styles.actionLabel}>{label}</span>
    </button>
  );
};

// 검색 결과 한 줄도 목록 타일과 같은 부품을 쓴다. 예전에는 사진 있는 행과
// 핀 아이콘만 있는 행이 섞여 목록이 들쭉날쭉했다.
export const PlaceSuggestionRow = ({
  place,
  userLocation,
  onClick,
  variant = "mobile",
  showDistance = false,
  useTitleFallback = false,
  fallbackName = "",
  isActive = false,
  onMouseEnter,
}) => {
  const category = place?.type || place?.category || place?.subcategory || "";
  const closureRisk = place?.localdataClosureRisk;
  const region = getRegionFromAddress(place);
  const distanceText = showDistance
    ? formatDistance(
        place?.distance || place?.dist || getDistanceMeters(userLocation, place)
      )
    : "";
  const name = place?.name || (useTitleFallback ? place?.title : "") || fallbackName;
  const matchedMenuItem = Array.isArray(place?.menuMatchedItems)
    ? place.menuMatchedItems[0]
    : "";
  const warningLabel = closureRisk?.publicWarning
    ? closureRisk.label || "영업 확인 필요"
    : "";
  const metaParts = [
    matchedMenuItem ? `메뉴 · ${matchedMenuItem}` : "",
    warningLabel,
  ].filter(Boolean);

  return (
    <div onMouseEnter={onMouseEnter}>
      <ListTile
        verified={Boolean(place?.storeAccountVerifiedAt)}
        imageUrl={getCoverImageUrl(place)}
        title={name}
        subtitle={[category, region, distanceText].filter(Boolean).join(" · ")}
        meta={metaParts.length ? metaParts.join(" · ") : null}
        onClick={onClick}
        active={isActive}
        thumbSize={variant === "desktop" ? "h-[69px] w-[52px]" : undefined}
      />
    </div>
  );
};
